import logoDark from "../../assets/images/shared/desktop/logo-dark.png";
import logoLight from "../../assets/images/shared/desktop/logo-light.png";
import facebook from "../../assets/images/shared/desktop/icon-facebook.svg";
import youtube from "../../assets/images/shared/desktop/icon-youtube.svg";
import twitter from "../../assets/images/shared/desktop/icon-twitter.svg";
import pinterest from "../../assets/images/shared/desktop/icon-pinterest.svg";
import instagram from "../../assets/images/shared/desktop/icon-instagram.svg";

export const menuData = {
  header: {
    headerLogo: logoDark,
    headerLogoAlt: "bittech software agency",
    label: "visit homepage",
  },
  footer: {
    footerLogo: logoLight,
    footerLogoAlt: "bittech software agency",
    label: "go back to homepage",
  },
  homeLink: "/",
  address: {
    office: "Sukkur IBA Incubator #04",
    street: "Airport Road",
    city: "Sukkur",
  },
  contact: {
    title: "Contact Us",
    phone: "+923053911334",
    phoneLink: "tel:+1 253-863-8967",
    phoneLabel: "call us via our official number",
    email: "contact@bittech.com",
    emailLink: "mailto:contact@bittech.com",
    emailLabel: "send us an email",
  },
  social: [
    {
      label: "follow us on facebook",
      icon: facebook,
      link: "https://facebook.com.bittech",
    },
    {
      label: "subscribe to our youtube channel",
      icon: youtube,
      link: "https://youtube.com.bittech",
    },
    {
      label: "follow us on twitter",
      icon: twitter,
      link: "https://twitter.com.bittech",
    },
    {
      label: "join us on pinterest",
      icon: pinterest,
      link: "https://pinterest.com.bittech",
    },
    {
      label: "follow us on instagram",
      icon: instagram,
      link: "https://instagram.com.bittech",
    },
  ],
  menu: [
    {
      title: "our company",
      link: "/about",
      label: "visit about page",
    },
    {
      title: "contact",
      link: "/contact",
      label: "visit contact page",
    },
  ],
};
